import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { FormButton } from '../Button';
import { DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

type PopupConfirmDelayProps = {
  open: boolean;
  message?: string;
  description?: string;
  delay?: number;
  setDelay?: Dispatch<SetStateAction<number>>;
  handleClick: () => void;
  handleClose: () => void;
};

const PopupConfirmDelay = ({
  open,
  message,
  description,
  delay,
  setDelay,
  handleClick,
  handleClose,
}: PopupConfirmDelayProps) => {
  const { t, i18n } = useTranslation();
  const activeLocale = i18n.resolvedLanguage;
  const m = t('popup-delete-title');
  const d = t('popup-delete-description');
  const [minute, setMinute] = useState(0);

  useEffect(() => {
    setMinute(delay || 0);
  }, [delay]);

  const handleChange = (event: any) => {
    setMinute(event.target.value);
    setDelay && setDelay(event.target.value);
  };

  console.log('minute', minute);

  return (
    <TransparentDialog onClose={handleClose} open={open}>
      <DialogTitleContainer>{message || m}</DialogTitleContainer>
      <DialogContentContainer>
        <p>{description || d}</p>
        <FormControl fullWidth>
          <InputLabel id="minute-label">
            {activeLocale === 'fr' ? 'Secondes' : 'Seconds'}
          </InputLabel>
          <Select
            labelId="minute-label"
            value={minute}
            label="Minutes"
            onChange={handleChange}
          >
            {Array.from({ length: 61 }, (_, i) => (
              <MenuItem key={i} value={i}>
                {i}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContentContainer>
      <DialogActionsContainer>
        <FormButton
          buttonLabel={t('button-cancel')}
          color={'grey'}
          OnClick={handleClose}
          style={{
            marginRight: 10,
            borderRadius: 6,
            border: '1px solid #F0F0F0',
          }}
        />
        <FormButton
          buttonLabel={t('button-confirm')}
          color={'primary'}
          OnClick={handleClick}
          style={{
            borderRadius: 6,
          }}
        />
      </DialogActionsContainer>
    </TransparentDialog>
  );
};

const TransparentDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: '#00000033',
  },
  '& .MuiDialog-paper': {
    borderRadius: 16,
  },
}));

const DialogTitleContainer = styled(DialogTitle)(() => ({
  paddingTop: 32,
  paddingInline: 48,
}));

const DialogContentContainer = styled(DialogContent)(() => ({
  paddingTop: '32px !important',
  paddingInline: 30,
  paddingBottom: 32,
}));

const DialogActionsContainer = styled(DialogActions)(() => ({
  paddingInline: 48,
  paddingBottom: 32,
}));

export default PopupConfirmDelay;
